<template>
<div class="my-favorite-college-wrapper">

  <el-page-header class="head" @back="onBack" content="我的志愿" />

  <el-card class="box-card">
    <el-table class="data-table"
      :data="datas"
      style="width: 100%"
      highlight-current-row
      >
      <el-table-column prop="collegeName" label="大学"></el-table-column>
      <el-table-column prop="majorName" label="专业"></el-table-column>
      <el-table-column prop="score" label="分数"></el-table-column>
      <el-table-column prop="rank" label="排名"></el-table-column>
      <el-table-column prop="region" label="区域"></el-table-column>
      <el-table-column prop="grade" label="专业层次"></el-table-column>
      <el-table-column prop="subjectConstraint" label="科目限制"></el-table-column>

      <el-table-column label="顺序" width="80">
        <template slot-scope="scope">
          <div class="button-box">
            <div class="column">
              <i class="el-icon-arrow-up button up" @click="onUp(scope.$index, scope.row)"  />
              <i class="el-icon-caret-top button top" @click="onTop(scope.$index, scope.row)"  />
            </div>
            <div class="column">
              <i class="el-icon-arrow-down button down" @click="onDown(scope.$index, scope.row)"  /> 
              <i class="el-icon-caret-bottom button bottom" @click="onBottom(scope.$index, scope.row)"  /> 
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="删除" width="50">
        <template slot-scope="scope">
          <div class="delete-column">
            <i class="el-icon-delete" @click="onDelete(scope.$index, scope.row)"  /> 
          </div>
        </template>
      </el-table-column>

    </el-table>

  </el-card>

</div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'MyFavoriteCollege',
  data () {
    return {
      datas:[],
      initDatas: [],
    }
  },
  computed: {
    // 将vuex中的全局变量subjects映射为组件的局部变量
    ...mapState({
      userinfo: 'userinfo'
    }),
  },
  mounted(){
    this.loadData()
  },
  beforeDestroy(){
    this.saveFavoritesSort()
  },
  methods: {
    loadData(){
      const that = this
      let params = {
        'userid': that.userinfo.id
      }
      that.axios.get('/user/querymyfavoritecolleges', {params})
      .then((ret)=>{
        let {code,message,data} = ret
        if(code===0){
          that.datas = data
          that.initDatas = JSON.parse(JSON.stringify(that.datas))

        }else{
          that.$message('查询失败')
          that.$message(message)
        }
      })
    },
    onUp(index){
      this.util.up(this.datas,index)
    },
    onDown(index){
      this.util.down(this.datas,index)
    },
    onTop(index){
      this.util.top(this.datas,index)
    },
    onBottom(index){
      this.util.bottom(this.datas,index)
    },
    onDelete(index){
      const that = this

      let deletedRows = []
      deletedRows.push(that.datas[index])

      if(deletedRows.length==0)
        return

      let jsonStr = JSON.stringify(deletedRows)
      const params = new FormData()
      params.append('userid', that.userinfo.id)
      params.append('json', jsonStr)

      that.axios.post('/homepage/selectcollege/savefavorites', params)
      .then((ret)=>{
        let {code,message} = ret
        if(code===0){
          that.loadData()
          that.$message('保存成功')
        }else{
          that.$message('查询失败')
          that.$message(message)
        }
      })
    },
    saveFavoritesSort(){
      const that = this

      if(that.datas.length==0)
        return

      that.datas.forEach((item,index)=>{
        item.sortIndex = index+1
      })
      
      let jsonStr = JSON.stringify(that.datas)
      const params = new FormData()
      params.append('json', jsonStr)

      that.axios.post('/user/savefavoritessort', params)
      .then((ret)=>{
        let {code,message} = ret
        if(code===0){
          that.$message('保存成功')
        }else{
          that.$message('查询失败')
          that.$message(message)
        }
      })
    },
    onBack(){
      this.$router.back()
    },
  }
}
</script>

<style lang="stylus" scoped>
.my-favorite-college-wrapper
  margin: 40px 40px 50px 40px
  .head
    margin-bottom: 20px
  .data-table
    .button-box
      display: flex
      flex-wrap: wrap
      align-content: stretch
      .column
        flex-basis: 100%
        display: flex
        justify-content: space-between
        .button
          font-size: 20px
          margin-right: 5px
          color: #aaaaaa
          &:hover
            color: #333333
            font-weight: bold
            cursor: pointer
    .delete-column
      font-size: 20px
      color: #aaaaaa
      &:hover
        color: #333333
        font-weight: bold
        cursor: pointer
</style>
